import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import _ from "lodash";
import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import StaticDatePicker from '@mui/lab/StaticDatePicker';
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';
import Divider from "@mui/material/Divider";
import moment from "moment";
import {BackIcon} from '../../components/icons/icons';
import clsx from 'clsx';
import CloseIcon from '@mui/icons-material/Close';
import AgyleDatePicker from '../../components/ui/fields/agyleDatePicker';
import config from '../../app/config';
import {Checkbox} from '@mui/material';
import {getTableScrollbar} from '../../util/scrollbar';

const useStyles = makeStyles((theme) => ({
    popper: {
        zIndex: theme.zIndex.drawer - 1,
    },
    filterLabel: {
        textTransform: "uppercase",
        fontWeight: 300,
    },
    listElement: {
        fontSize: "90%",
        textTransform: "uppercase",
        fontWeight: 300,
        display: "flex", justifyContent: "space-between", width: "100%"
    },
    listElementModal: {
        fontSize: 12,
        wordBreak: "break-all",
        textTransform: "uppercase",
        fontWeight: 300,
        display: "flex", width: "100%",
        padding: 0,
        whiteSpace: "break-spaces", textAlign: "left"
    },
    textField: {
        background: "#3D3E40",
        border: "1px solid #A4A7AB"
    },
    filterNameInModal: {
        color: "#FFF",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "normal",
        display: "flex",
        alignItems: "center",
       // justifyContent: "center",
     //   height: 32,
        width: 110,
        //marginBottom: 10
    },
    filterButton: {
        cursor: "pointer",
        fontSize: 13,
        minWidth: 50,
        background: "#3D3E40",
        padding: 10,
        height: 36,
        borderRadius: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        gap: 10
    },
    filterModalName: {
        cursor: "pointer",
        fontSize: 13,
        minWidth: 50,
        background: "#3D3E40",
      //  padding: 10,
        borderRadius: 20,
        display: "flex",

        gap: 10
    },
    filterSet: {
      background: "white",
      color: "black"
    },
    clearButton:{
        padding: "0",
        minWidth: "20px"
    },
    icon:{
        fontSize: "15px"
    },
    filterName: {
        textAlign: "left",
        fontSize: "11px",
        marginLeft: "15px",
        marginTop: "-9px",
        background: "#252525",
        width: "fit-content",
        padding: "0px 4px",
        cursor: "pointer",
        color: "#2280f7",
        display: "flex",
        alignItems: "center"
    }
}));

export function EyonixFilterAddButton(props) {
    const [elements, setElements] = React.useState([]);
    const [selectedElements, setSelectedElements] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(undefined);

    const {t, i18n} = useTranslation();

    const filter = props.config.filter;
    const defaultDateValue = filter.default ? moment().startOf("day").subtract(
        filter.default[0], filter.default[1]) : null;
    const [dateValue, setDateValue] = React.useState(defaultDateValue);

    const anchorRef = React.useRef(null);
    const classes = useStyles();

    useEffect(() => {
        if (defaultDateValue) {
            if (props.onChange) {
                props.onChange(defaultDateValue);
            }
        }
    }, []);

    useEffect(()=>{
        if(filter.type === "date") {
            if(filter.__filterValue)
                setDateValue(moment(filter.__filterValue))
            else
                setDateValue(null)
        } else {
            let index = _.findIndex(elements, (el) => {
                return el === filter.__filterValue
            });
            if(index>0)setSelectedIndex(index);
        }
    },[elements]);

    const updateDateValue = date => {
        setOpen(false);
        setDateValue(date);
        if (props.onChange) {
            props.onChange(date);
        }
    };

    const updateSelected = (index) => {
        setSelectedIndex(index);
        if (props.onChange) {
            props.onChange(index !== undefined ? elements[index] : undefined);
        }
    };
    const updateSelected2 = (index) => {
        //setSelectedIndex(index);
        if (props.onRemove) {
            props.onRemove(index !== undefined ? selectedElements[index] : undefined);
        }
    };
    const handleMenuItemClick = (event, index) => {
        if(!props.dontCloseOnChoose) {
            setOpen(false);
        }
        updateSelected(index);
    };
    const handleRemoveMenuItemClick = (event, index) => {
        event.stopPropagation();
        event.preventDefault();
        if(!props.dontCloseOnChoose) {
            setOpen(false);
        }
        updateSelected2(index);
    };

    const handleToggle = (e) => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    useEffect(() => {
        let elementsLocal = new Set();
        let elementsSelectedLocal = new Set();
        if (props.data) {
            _.forEach(props.data, dataElement => {
                // const val = _.get(dataElement, props.field, t("Undefined"));
                const val = _.get(dataElement, props.field, null);
                if(filter.type === "string" && !props.filtersValues?.includes(val))
                    elementsLocal.add(val);
                else
                    elementsSelectedLocal.add(val);
            });
        }
        if(props.filtersValues && _.isArray(props.filtersValues)){
            props.filtersValues?.forEach((value)=>{
                elementsSelectedLocal.add(value)
            })
        }

        setElements(_.sortBy(Array.from(elementsLocal), function (v) {
            return v ? v.toLowerCase() : "";
        }));
        setSelectedElements(_.sortBy(Array.from(elementsSelectedLocal), function (v) {
            return v ? v.toLowerCase() : "";
        }));
    }, [props.data, props.field, props.filtersValues]);

    const renderValue = what => {
        let returnValue = (props.render ? props.render(what) : what);
        if (!returnValue) {
            returnValue = t("Undefined");
        }
        return returnValue;
    };

    const renderDateValue = what => {
        let returnValue = (props.render ? props.render(what) :
            (what ? what.format(filter.format) : ""));
        if (!returnValue) {
            returnValue = t("No date");
        }
        return returnValue;
    };

    const renderFullOptions = () => {
        return <div>
            {filter.type === "date" &&
                <div className={clsx(classes.filterModalName)}  ref={anchorRef} onClick={handleToggle}>
                    <div className={classes.filterNameInModal}> { props.config.name} </div>
                    <AgyleDatePicker
                        inputFormat={config.defaultDateFormat}
                        label={""}
                        type={"date"}
                        ampm={false}
                        textFieldClass={classes.textField}

                        value={dateValue}
                        size="small"
                        onChange={updateDateValue}

                    />
                </div>
            }

            {filter.type === "string" &&
                <div className={classes.filterModalName}>
                    <span className={classes.filterNameInModal}>{props.config.name}</span>
                </div>
            }

            <div>
            {filter.type === "string" && selectedElements.length > 0 &&
            <MenuList>
                {selectedElements.map((option, index) => (
                    <MenuItem
                        className={classes.listElementModal}
                        key={option}
                        onClick={(event) => handleRemoveMenuItemClick(event, index)}
                    >
                        <Checkbox
                            style={{ padding: "5px 10px 5px 0", color: "white"}}
                            checked={true}
                        />
                        <div> {renderValue(option)} </div>

                    </MenuItem>
                ))}
            </MenuList>
            }
            {selectedElements.length > 0 && filter.type === "string" && <Divider/>}
            {filter.type === "string" &&
                <MenuList>
                {elements.map((option, index) => (
                    <MenuItem
                        className={classes.listElementModal}
                        key={option}
                        onClick={(event) => handleMenuItemClick(event, index)}
                    >
                        <Checkbox
                            checked={false}
                            style={{ padding: "5px 10px 5px 0" }}
                            onChange={(event)=>{

                            }}
                        />
                        {renderValue(option)}
                    </MenuItem>
                ))}
            </MenuList>
            }

        </div> </div>
    }
    const renderTagsOptions = () => {
        return <div>
            {filter.type === "date" &&
                <div className={clsx(classes.filterButton, filter.__filterValue && classes.filterSet)}  ref={anchorRef} onClick={handleToggle}>
                {!filter.__filterValue && <span> Set { props.config.name} </span>}
                {filter.__filterValue && <span> { props.config.name.split(" ").pop()} </span>}
                {!filter.__filterValue && <BackIcon style={{transform: "rotate(-90deg)"}} fontSize={"small"}/> }

                {filter.__filterValue && <b>{moment(filter.__filterValue).format("DD/MM/YYYY")}</b>}
                {filter.__filterValue &&  <CloseIcon  onClick={(event) => handleRemoveMenuItemClick(event)} fontSize={"small"}  />}
            </div>
            }

            {filter.type === "string" &&
                <div className={clsx(classes.filterButton, selectedElements.length > 0 && classes.filterSet)}  ref={anchorRef} onClick={handleToggle}>
                <span>{props.config.name}</span>
                {selectedElements.length === 0 && <BackIcon style={{transform: "rotate(-90deg)"}} fontSize={"small"}/> }
                {selectedElements.length > 0 && <b style={{minWidth: 20}}>{selectedElements.length}</b>}
            </div>
            }

            <Popper className={classes.popper} open={open}
                    placement="bottom-start"
                    anchorEl={anchorRef.current} role={undefined} transition
                    disablePortal>
                {({TransitionProps, placement}) => (
                    <Grow {...TransitionProps}>
                        <Paper className={getTableScrollbar()}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <div>
                                    {filter.type === "string" && selectedElements.length > 0 &&
                                        <MenuList style={{maxHeight: `calc(100vh - ${102+selectedElements.length*36 + ((selectedElements.length>0) ? 14 : 0) }px)`}}>
                                            {selectedElements.map((option, index) => (
                                                <MenuItem
                                                    className={classes.listElement}
                                                    key={option}

                                                >
                                                    <div> {renderValue(option)} </div>
                                                    <CloseIcon onClick={(event) => handleRemoveMenuItemClick(event, index)}/>

                                                </MenuItem>
                                            ))}
                                        </MenuList>
                                    }
                                    {selectedElements.length > 0 && <Divider/>}
                                    {filter.type === "string" &&
                                        <MenuList style={{maxHeight: `calc(100vh - ${102+selectedElements.length* 36+ ((selectedElements.length>0) ? 14 : 0)}px)`}}>
                                            {elements.map((option, index) => (
                                                <MenuItem
                                                    className={classes.listElement}
                                                    key={"element-" + option + "-" + index}
                                                    onClick={(event) => handleMenuItemClick(event, index)}
                                                >
                                                    {renderValue(option)}
                                                </MenuItem>
                                            ))}
                                        </MenuList>
                                    }
                                    {filter.type === "date" &&
                                    <StaticDatePicker
                                        // autoOk
                                        showToolbar={false}
                                        value={dateValue}
                                        onChange={updateDateValue}
                                        renderInput={(inp) => <TextField {...inp} />}
                                    />
                                    }
                                </div>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>

        </div>
    }
    return (
        <div style={{textAlign: "center"}} >
            {props.fullView && renderFullOptions()}
            {!props.fullView && renderTagsOptions()}
        </div>

    );
}
